import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

const badgeVariants = cva(
	'inline-flex items-center rounded-full px-4 py-0.5 font-bold text-xs',
	{
		defaultVariants: {
			size: 'default',
			variant: 'default',
		},
		variants: {
			size: {
				default: 'h-[32px] text-sm',
				sm: 'h-[20px] px-2',
			},
			variant: {
				default: 'border-transparent bg-white',
				error:
					'border-transparent bg-red-100 text-red-600 [a&]:hover:bg-red-600/90',
				outline:
					'border border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
				primary:
					'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
				secondary:
					'border-transparent bg-secondary px-2 text-secondary-foreground text-xs',
				success:
					'border-transparent bg-green-100 text-green-600 [a&]:hover:bg-green-600/90',
				warning:
					'border-transparent bg-yellow-100 text-yellow-600 [a&]:hover:bg-yellow-600/90',
			},
		},
	},
)

export interface BadgeProps
	extends
		React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
	({ className, variant, size, ...props }, ref) => {
		return (
			<div
				className={cn(badgeVariants({ size, variant }), className)}
				ref={ref}
				{...props}
			/>
		)
	},
)

Badge.displayName = 'Badge'

export { Badge, badgeVariants }
